import { useDataClient } from "../hooks/client.hooks";
import { BootstrapRequestDTO } from "../open-api";

export const useBootstrap = () => useDataClient<BootstrapRequestDTO>(`/api/auth/bootstrap`);
